import { useEffect, useRef, useState } from "react";
import { MapPin, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export const TownPicker = ({ value, onChange }) => {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, setErr] = useState("");
  const timer = useRef(null);

  useEffect(() => {
    clearTimeout(timer.current);
    if (q.trim().length < 3) { setItems([]); return undefined; }
    timer.current = setTimeout(async () => {
      setBusy(true);
      try {
        setErr("");
        setItems((await api.get("/geo/towns", { params: { q: q.trim() } })).data);
        setOpen(true);
      } catch (e) { setItems([]); setErr(errMsg(e)); setOpen(true); } finally { setBusy(false); }
    }, 400);
    return () => clearTimeout(timer.current);
  }, [q]);

  return (
    <div className="relative" data-testid="town-picker">
      {value?.name && !open && (
        <div className="flex items-center gap-2 mb-2 text-sm text-sky-800 bg-sky-500/10 border border-sky-500/30 rounded-lg px-3 py-2" data-testid="town-selected">
          <MapPin className="w-4 h-4" /> <b>{value.name}</b>{value.province ? <span className="text-slate-500">· {value.province}</span> : null}
        </div>
      )}
      <div className="relative">
        <Input value={q} onChange={(e) => setQ(e.target.value)} onFocus={() => items.length && setOpen(true)}
          placeholder={value?.name ? "Cambiar población…" : "Escriba el municipio (p. ej. Poio, Bueu, Pontevedra)"} data-testid="town-search-input" />
        {busy && <Loader2 className="w-4 h-4 animate-spin absolute right-3 top-1/2 -translate-y-1/2 text-slate-500" />}
      </div>
      {open && q.trim().length >= 3 && (
        <div className="absolute z-50 mt-1 w-full max-h-56 overflow-y-auto bg-slate-50 border border-slate-200 rounded-lg shadow-xl" data-testid="town-results">
          {err && <div className="px-3 py-2 text-xs text-red-700" data-testid="town-search-error">{err}</div>}
          {!err && !items.length && !busy && <div className="px-3 py-2 text-xs text-slate-500" data-testid="town-no-results">Sin resultados</div>}
          {items.map((t, i) => (
            <button key={`${t.name}-${i}`} type="button" onClick={() => { onChange(t); setQ(""); setItems([]); setOpen(false); }} data-testid={`town-option-${i}`}
              className="w-full text-left px-3 py-2 text-sm hover:bg-slate-100 flex items-center gap-2">
              <MapPin className="w-3.5 h-3.5 text-sky-600 shrink-0" /><span className="text-slate-900">{t.name}</span><span className="text-xs text-slate-500 truncate">{t.province}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
